import styled from "styled-components";
import { getWeatherImage } from "../../../utils/utils";
import React from "react";

const WeatherCard = ({ weather, value }) => {
  return (
    <Card>
      <ImgWeather src={getWeatherImage(weather)} alt="icone météo" />
      <h3>{value}</h3>
    </Card>
  );
};
const Card = styled.div`
  box-shadow: 1px 1px 5px rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  background-color: var(--color-white);
  border-radius: 15px;
  padding: 1rem 2rem;

  h3 {
    font-size: 22px;
    font-weight: 800;
  }
  @media print {
    page-break-inside: avoid;
    gap: 4px;
    padding: 1rem;
    box-shadow: none;
  }
`;
const ImgWeather = styled.img`
  height: 3.5rem;
  width: 3.5rem;
  @media (min-width: 1100px) {
    height: 4rem;
    width: 4rem;
  }
`;
export default WeatherCard;
